export default {
  alias      : 'regulation_sinc_result',
  route      : '/app/normatividad/regulation_sinc_result',
  hash       : false,
  store      : false,
  name       : 'res_resultado',
  key        : 'id',
  selectable : true,
  /*relations : [
      {
          attribute : 'unidades',
          alias     : 'unidades',
          module    : 'unit'
      }
    ],*/
  default    : {
    id            : null,
    res_date      : null,
    tip_siglas    : [],
    admin_idadmin : false,
    res_resultado : false,
    created_at    : null,
    updated_at    : null,
  }
}
